import { getDigitalTrackingCodesFromUtms } from '@sky-distribution/gp-digital-submission-service';
import { getTrackingCodesFromUtms } from '@sky-distribution/gp-onboarding-policy-service';
import { getSearchParams } from '@sky-distribution/gp-onboarding-shared-utils';
import { clearSearchParams } from './clearSearchParams.util';

export const getUtmParamsFromSearchParams = (queryStringParams: URLSearchParams): Record<string, string> => {
  const utmPrefix = 'utm_';
  const utms = Array.from(queryStringParams.entries())
    .filter(
      ([queryStringParamName]) => queryStringParamName.startsWith(utmPrefix),
    );

  return utms.reduce((utmDict, [name, value]) => ({
    ...utmDict,
    [name]: value,
  }), {});
};

export const getTrackingCodes = () => {
  const params = getSearchParams();
  const utms = getUtmParamsFromSearchParams(params);
  const trackingCodes = getTrackingCodesFromUtms(utms);

  if (!trackingCodes) {
    return undefined;
  }

  return trackingCodes;
};

export const getDigitalTrackingCodes = () => {
  const params = getSearchParams();
  const utms = getUtmParamsFromSearchParams(params);
  const trackingCodes = getDigitalTrackingCodesFromUtms(utms);

  if (!trackingCodes) {
    return undefined;
  }

  return trackingCodes;
};

export const clearTrackingCodesFromUrl = () => {
  const utms = getUtmParamsFromSearchParams(getSearchParams());
  clearSearchParams(Object.keys(utms));
};
